import React from 'react';
import { Box } from '@chakra-ui/react';
import { ISubmissionContext } from '@publishing-engine/domain/models';

import { GeneralInfo } from '../GeneralInfo';
import JournalConfig from '../JournalConfig';
import SubmissionStepsContentConfig from '../SubmissionStepContentConfig';
import FocusIssue from '../FocusIssue';
import ResponseTemplates from '../ResponseTemplates';
import SectionNavLayout from './SectionNavLayout';

const GENERAL_SETTINGS_SECTIONS = [
  { id: 'general-info', label: 'General Info' },
  { id: 'journal-config', label: 'Reason Configurations' },
  { id: 'submission-steps-content', label: 'Submission Steps Content' },
  { id: 'focus-issue', label: 'Special Issue' },
  { id: 'response-templates', label: 'Pre-filled Responses' }
];

interface GeneralSettingsTabProps {
  journal: ISubmissionContext;
  guidelineLink: string | undefined;
  isActive: boolean | undefined;
  journalId: string;
}

const GeneralSettingsTab: React.FC<GeneralSettingsTabProps> = ({
  journal,
  guidelineLink,
  isActive,
  journalId
}) => {
  return (
    <SectionNavLayout title="General Settings" sections={GENERAL_SETTINGS_SECTIONS}>
      <Box id="general-info">
        <GeneralInfo journal={journal} isActive={isActive} />
      </Box>
      <Box id="journal-config">
        <JournalConfig journal={journal} />
      </Box>
      <Box id="submission-steps-content">
        <SubmissionStepsContentConfig journal={journal} />
      </Box>
      <Box id="focus-issue">
        <FocusIssue guidelineLink={guidelineLink} />
      </Box>
      <Box id="response-templates">
        <ResponseTemplates journalId={journalId} />
      </Box>
    </SectionNavLayout>
  );
};

export default React.memo(GeneralSettingsTab);
